import React, { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import dateUtils from '../../Utils/dateUtils';
import Modal from "../Modal";

function MigrationList({ migrations }) {
    const { t } = useTranslation();
    const [selectedMigration, setSelectedMigration] = useState(null);

    const sortedMigrations = useMemo(() => {
        return [...migrations].sort((a, b) => new Date(b.created) - new Date(a.created));
    }, [migrations]);

    const closeModal = () => setSelectedMigration(null);

    const getStatusClass = (statusCode) => {
        switch (statusCode) {
            case 0: return '';
            case 1: return 'text-primary';
            case 2: return 'text-success';
            case 3: return 'text-danger';
            default: return '';
        }
    };

    const formatLogMessage = (entry) => {
        const itemName = entry.itemName || '';
        const identifier = entry.identifier || '';
        const includesIdentifier = itemName &&
            itemName !== 'Företagsinformation' &&
            itemName !== 'Företagsinställningar' &&
            !!identifier;
        const prefix = itemName + (includesIdentifier ? ` ${identifier}` : '');
        const separator = (itemName || identifier) ? ': ' : '';
        return `${prefix}${separator}${entry.message ?? ''}`;
    };

    return (
        <div className="col-xs-12" style={{ overflowX: 'auto', maxWidth: '100%', width: 0, minWidth: '100%' }}>
            <table className="table table-stripe" style={{ whiteSpace: 'nowrap' }}>
                <thead>
                    <tr>
                        <th className="text-left">{t('migrations.migrationType')}</th>
                        <th className="text-left">{t('migrations.sourceType')}</th>
                        <th className="text-left">{t('migrations.status')}</th>
                        <th className="text-left">{t('migrations.eAccountingGuideState')}</th>
                        <th className="text-left">{t('migrations.created')}</th>
                        <th className="text-left">{t('migrations.started')}</th>
                        <th className="text-left">{t('migrations.done')}</th>
                        <th className="text-left">{t('migrations.changed')}</th>
                        <th className="text-center" style={{ width: 120 }}></th>
                    </tr>
                </thead>
                <tbody>
                    {sortedMigrations.map((migration) => (
                        <tr key={migration.migrationId}>
                            <td>{migration.migrationType?.name}</td>
                            <td>{migration.sourceType?.name}</td>
                            <td className={getStatusClass(migration.status?.code)}>{migration.status?.name}</td>
                            <td>{migration.eAccountingGuideState?.name}</td>
                            <td>{dateUtils.formatDateAndTime(migration.created)}</td>
                            <td>{migration.startedAt ? dateUtils.formatDateAndTime(migration.startedAt) : ''}</td>
                            <td>{migration.doneAt ? dateUtils.formatDateAndTime(migration.doneAt) : ''}</td>
                            <td>{dateUtils.formatDateAndTime(migration.changed)}</td>
                            <td className="text-center">
                                {migration.customerLog?.length > 0 && (
                                    <button className="btn btn-default btn-sm" onClick={() => setSelectedMigration(migration)}>
                                        <span className="vismaicon vismaicon-sm vismaicon-history" /> {t('migrations.log')} ({migration.customerLog.length})
                                    </button>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {selectedMigration && (
                <Modal
                    title={t('migrations.log')}
                    onCancelClick={closeModal}
                    stateful
                    open
                    showButtons={false}
                    customClassName="modal-lg"
                >
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>{t('migrations.logMessage')}</th>
                                <th>{t('migrations.logDate')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {selectedMigration.customerLog.map((entry, index) => (
                                <tr key={index}>
                                    <td>{formatLogMessage(entry)}</td>
                                    <td className="text-nowrap">{dateUtils.formatDateAndTime(entry.dateTime)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Modal>
            )}
        </div>
    );
}

export default MigrationList;
